import { GlobalConfigType, SET_GLOBAL_CONFIG } from 'actions'

import { createReducer } from '../utils'

const getInitialState = (): Record<GlobalConfigType, any> => {
  return {
    [GlobalConfigType.LoanStatus]: {},
    [GlobalConfigType.LoanFields]: {},
    [GlobalConfigType.PagePermissions]: {},
    [GlobalConfigType.Footer]: {},
    [GlobalConfigType.ConditionTypes]: [],
    [GlobalConfigType.DocumentCategory]: [],
    [GlobalConfigType.GlobalSettingV2]: {},
    [GlobalConfigType.LoanSubmissionHierarchy]: [],
    [GlobalConfigType.GUARANTER_CONFIG]: {},
    [GlobalConfigType.ORDER_VALUATION]: {},
    [GlobalConfigType.ACCOUNT_TYPES]: {},
    [GlobalConfigType.PARTIES]: {},
    [GlobalConfigType.EMAIL_OPTIONS]: {},
    [GlobalConfigType.GTM]: {},
    [GlobalConfigType.RulesConfig]: {},
    [GlobalConfigType.IneligibleParties]: {},
    [GlobalConfigType.SecondaryMarketing]: {},
  }
}

export const globalConfigReducer = createReducer(getInitialState(), {
  [SET_GLOBAL_CONFIG]: (state: any, { payload }: { payload: { type: GlobalConfigType; value: any } }) => {
    return {
      ...state,
      [payload.type]: payload.value,
    }
  },
})
